// @ts-ignore
__webpack_public_path__ = new URL(document.currentScript.src).origin + '/';

Object.assign(self, {
  app2: __webpack_require__('webpack/container/entry/sso'),
});
